"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableChipTextColor = exports.VariableChipBorderColor = exports.VariableChipBackgroundColor = exports.PrimaryMainColor = void 0;
exports.PrimaryMainColor = "#5555E7";
exports.VariableChipBackgroundColor = "#F8F8FF";
exports.VariableChipBorderColor = "#BFBFFF";
exports.VariableChipTextColor = "#2A2AC4";
